/** Line icons in the concepts' ink style. */
const svg = (size: number, children: React.ReactNode, color = 'currentColor') => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    {children}
  </svg>
);

export const BrushGlyph = ({ size = 20 }: { size?: number }) =>
  svg(size, <>
    <circle cx="12" cy="12" r="10" />
    <path d="M16 7l-5 6M10.5 13.5c-1.5.2-2.5 1.4-2.6 3 1.6 0 2.9-.8 3.3-2.3" />
  </>);
export const BookGlyph = ({ size = 20 }: { size?: number }) => svg(size, <path d="M3 5c3-1 6-1 9 1 3-2 6-2 9-1v14c-3-1-6-1-9 1-3-2-6-2-9-1zM12 6v14" />);
export const BoltGlyph = ({ size = 20 }: { size?: number }) => svg(size, <path d="M13 2L4 14h7l-1 8 9-12h-7z" />);
export const MicGlyph = ({ size = 20 }: { size?: number }) => svg(size, <><rect x="9" y="2" width="6" height="12" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v4" /></>);
export const ShirtGlyph = ({ size = 20 }: { size?: number }) => svg(size, <path d="M8 3l4 3 4-3 5 4-3 4-2-1v11H8V10l-2 1-3-4z" />);
export const PencilGlyph = ({ size = 24 }: { size?: number }) => svg(size, <path d="M4 20l4-1 11-11-3-3L5 16zM14 6l3 3" />, '#fff');
export const TownGlyph = ({ size = 24 }: { size?: number }) => svg(size, <><rect x="4" y="4" width="10" height="17" /><path d="M14 10h6v11H14M7 8h1M10 8h1M7 12h1M10 12h1M7 16h1M10 16h1" /></>, '#0e0e10');
export const OpenBookGlyph = ({ size = 24 }: { size?: number }) => svg(size, <path d="M2 6c3-1 7-1 10 1 3-2 7-2 10-1v13c-3-1-7-1-10 1-3-2-7-2-10-1zM12 7v13" />, '#0e0e10');
export const PhoneGlyph = ({ size = 18 }: { size?: number }) => svg(size, <><rect x="7" y="2" width="10" height="20" rx="2" /><path d="M11 18h2" /></>, '#fff');
export const CheckGlyph = ({ size = 16 }: { size?: number }) => svg(size, <path d="M4 12l5 5L20 6" />);
export const HomeGlyph = ({ size = 22 }: { size?: number }) => svg(size, <path d="M3 11l9-7 9 7v10h-6v-6H9v6H3z" />);
export const BagGlyph = ({ size = 22 }: { size?: number }) => svg(size, <path d="M5 8h14l-1 13H6zM9 8V6a3 3 0 0 1 6 0v2" />);
export const UserGlyph = ({ size = 22 }: { size?: number }) => svg(size, <><circle cx="12" cy="8" r="4" /><path d="M4 21c1-4 4-6 8-6s7 2 8 6" /></>);
export const LogoutGlyph = ({ size = 22 }: { size?: number }) => svg(size, <path d="M10 4H5v16h5M14 8l4 4-4 4M18 12H9" />);

export function LockGlyph() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden>
      <rect x="4" y="10" width="16" height="11" rx="2" fill="currentColor" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" strokeWidth="2.4" />
    </svg>
  );
}

export function CrownGlyph() {
  return (
    <svg width="64" height="54" viewBox="0 0 32 26" aria-hidden>
      <path d="M2 6l7 7 7-11 7 11 7-7-3 15H5z" fill="#0e0e10" />
      <rect x="5" y="22" width="22" height="3" fill="#0e0e10" />
      <path d="M28 1l.8 2 2 .8-2 .8L28 7l-.8-2-2-.8 2-.8z" fill="#e0457f" />
    </svg>
  );
}

export function AppleGlyph() {
  return (
    <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden>
      <path fill="currentColor" d="M16.4 12.6c0-2.6 2.1-3.8 2.2-3.9-1.2-1.8-3.1-2-3.7-2-1.6-.2-3.1.9-3.9.9-.8 0-2-.9-3.4-.9-1.7 0-3.3 1-4.2 2.6-1.8 3.1-.5 7.7 1.3 10.2.9 1.2 1.9 2.6 3.2 2.6 1.3-.1 1.8-.8 3.3-.8s2 .8 3.4.8c1.4 0 2.3-1.3 3.1-2.5 1-1.4 1.4-2.8 1.4-2.9 0 0-2.7-1-2.7-4.1zM13.9 5c.7-.9 1.2-2 1.1-3.2-1 0-2.3.7-3 1.6-.7.8-1.3 2-1.1 3.1 1.1.1 2.3-.6 3-1.5z" />
    </svg>
  );
}
